import { motion } from "framer-motion";

const jobs = [
  {
    title: "Porch & Entry Cleanout",
    frames: [
      { src: "/jobs/job-porch-before.jpg", alt: "Porch packed wall-high with junk before cleanout", tag: "BEFORE" },
      { src: "/jobs/job-porch-after.jpg", alt: "The same porch completely cleared after cleanout", tag: "AFTER" },
    ],
  },
  {
    title: "Sunroom Cleanout",
    frames: [
      { src: "/jobs/job-room-before.jpg", alt: "Room filled with furniture and clutter before cleanout", tag: "BEFORE" },
      { src: "/jobs/job-room-after.jpg", alt: "The same room emptied out after cleanout", tag: "AFTER" },
    ],
  },
  {
    title: "Backyard & Fence Line",
    frames: [
      { src: "/jobs/job-yard-before.jpg", alt: "Backyard fence line buried under junk and debris before cleanout", tag: "BEFORE" },
      { src: "/jobs/job-yard.jpg", alt: "The same fence line cleared of junk after cleanout", tag: "AFTER" },
    ],
  },
  {
    title: "Kitchen Cleanout",
    frames: [
      { src: "/jobs/job-kitchen-before.jpg", alt: "Kitchen packed with clutter, bags and loose items before cleanout", tag: "BEFORE" },
      { src: "/jobs/job-kitchen-after.jpg", alt: "The same kitchen completely emptied after cleanout", tag: "AFTER" },
    ],
  },
];

const fade = (i) => ({
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
});

function Frame({ f, i }) {
  return (
    <motion.figure {...fade(i)} className="group self-start border border-navy/20 bg-white" data-testid={`work-frame-${f.tag.toLowerCase()}-${i}`}>
      <div className="relative">
        <img
          src={f.src}
          alt={f.alt}
          loading="lazy"
          className="block h-auto w-full"
        />
        <span className={`absolute left-0 top-0 px-4 py-2 font-mono2 text-[10px] uppercase tracking-[0.3em] text-white ${f.tag === "AFTER" ? "bg-royal" : "bg-navy"}`}>
          {f.tag}
        </span>
      </div>
    </motion.figure>
  );
}

export default function Work() {
  return (
    <section className="bg-white px-5 py-20 sm:px-10 lg:py-28 xl:px-16" data-testid="work-section">
      <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="mb-3 font-mono2 text-[11px] uppercase tracking-[0.35em] text-royal">Recent jobs</p>
          <h2 className="font-display text-5xl uppercase leading-none text-navy sm:text-7xl">
            Gone means gone.
          </h2>
        </div>
        <p className="max-w-xs text-sm text-navy/60 md:text-base">
          Real cleanouts, shot on site by the crew — packed to empty.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        {jobs.map((job, ji) => (
          <div key={job.title} data-testid={`work-job-${ji}`}>
            <div className="grid grid-cols-2 items-start gap-4">
              {job.frames.map((f, fi) => (
                <Frame key={f.tag} f={f} i={ji * 2 + fi} />
              ))}
            </div>
            <div className="flex items-center justify-between border border-t-0 border-navy/20 px-5 py-4">
              <span className="font-display text-lg uppercase text-navy">{job.title}</span>
              <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-navy/40">MA / RI</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
